export const isEmail = (value: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};

// 手机号长度
export const phoneLenMap = {
  // 巴西
  '55': 9,
  // 印度
  '91': 10,
};

// 方法2：手动遍历字符（兼容旧环境）
export function getByteLength(str: string) {
  let length = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    if (charCode <= 0x007F) {
      length += 1; // ASCII字符
    } else if (charCode <= 0xFFFF) {
      length += 3; // UTF-8中中文字符
    } else {
      length += 4; // 补充字符（如Emoji）
    }
  }
  return length;
}